import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialState = {
    countries: [],
    departments: [],
    industries: [],
    seniority: [],
};
const slice = createSlice({
    name: 'SEARCH_FILTERS',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setSearchFilters(state, { payload }) {
            state.countries = (payload === null || payload === void 0 ? void 0 : payload.countries) || [];
            state.departments = (payload === null || payload === void 0 ? void 0 : payload.departments) || [];
            state.industries = (payload === null || payload === void 0 ? void 0 : payload.industries) || [];
            state.seniority = (payload === null || payload === void 0 ? void 0 : payload.senioritis) || [];
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
